import { toCamelCase } from "@bonusmap/shared_ui/library";
import helpsClient from "../templates/helps.js";

export function helpContent(helpTopicId: string) {
    helpTopicId = toCamelCase(helpTopicId);
    // Cerca il template tra quelli predefiniti
    if (!helpsClient || typeof helpsClient !== 'object' || (helpsClient as any)[helpTopicId] === undefined) {
        // console.warn(`Template with id '${templateId}' not found in helpsClient`);
        return "";
    }
    const helpTopicContent: string = (helpsClient as any)[helpTopicId] || "";
    return helpTopicContent;
}